// Позиция узла среди братьев — строка дробного индекса над алфавитом 0-9a-z, сравнивается
// как строка. Вставка между соседями даёт новую строку, не меняя соседей, поэтому перенос
// одного узла — одно событие.
const ALPHABET = '0123456789abcdefghijklmnopqrstuvwxyz'
const BASE = ALPHABET.length

function digit(text: string, index: number): number {
  return index < text.length ? ALPHABET.indexOf(text[index]) : 0
}

/**
 * Строка строго между a и b: a null — от начала, b null — до конца. Если a не меньше b,
 * ответ идёт после a. Результат никогда не кончается на '0', поэтому между любыми двумя
 * позициями, выданными этой функцией, всегда есть место
 */
export function positionBetween(a: string | null, b: string | null): string {
  const low = a ?? ''
  let high: string | null = b !== null && b > low ? b : null
  let result = ''
  for (let i = 0; ; i++) {
    const lowDigit = digit(low, i)
    // верхняя граница кончилась: строки с таким префиксом длиннее её, места между нет — идём после
    if (high !== null && i >= high.length) {
      high = null
    }
    const highDigit = high === null ? BASE : ALPHABET.indexOf(high[i])
    if (highDigit - lowDigit > 1) {
      return result + ALPHABET[Math.floor((lowDigit + highDigit) / 2)]
    }
    result += ALPHABET[lowDigit]
    if (highDigit - lowDigit === 1) {
      high = null
    }
  }
}

/** Позиция после последнего из перечисленных (пусто — середина алфавита) */
export function positionAfter(positions: string[]): string {
  const last = positions.length === 0 ? null : positions.reduce((max, item) => (item > max ? item : max))
  return positionBetween(last, null)
}
